<mat-card class="content-card ng-star-inserted">
  <mat-card-header>
    <mat-card-title>
      <h5>
        {{ caption }}
        <span
          *ngIf="comments && comments.length > 0"
          style="display: inline-block; background-color: #9a9a9a; border-radius: 3px; padding: 2px 5px; margin: 0 5px; font-size: .8em">
            {{ comments.length }}
          </span>
      </h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div *ngIf="comments" class="comment-scroll">
      <div *ngFor="let comment of comments" class="object-comment">
        <div class="object-comment-header">
          <mat-icon
            [style.color]="severityColors.get(comment.severity) ?? 'white'"
            class="severity-icon object-comment-header-severity">
            {{ severityIcons.get(comment.severity) ?? 'circle' }}
          </mat-icon>
          {{ comment.text }}
          <span *ngIf="canDeleteComment(comment)" class="object-comment-delete">
            <a (click)="deleteObjectComment(comment.id)">
              <mat-icon color="accent">delete</mat-icon>
            </a>
          </span>
        </div>
        <div *ngIf="comment.date || comment.user" class="object-comment-body" fxLayout="row">
          <em>{{ getCommentInfo(comment) }}</em>
        </div>
      </div>
    </div>
    <br/>
    <table class="object-comment-input">
      <tr>
        <td>
          <mat-form-field class="object-comment-input-text">
            <input
              (keydown.enter)="addObjectComment()"
              [(ngModel)]="newCommentText"
              matInput
              maxlength="100"
              placeholder="New Comment (max 100 characters)"/>
          </mat-form-field>
        </td>
        <td style="width: 20%">
          <mat-form-field class="object-comment-input-severity">
            <mat-select [(ngModel)]="newCommentSeverity" placeholder="Severity">
              <mat-select-trigger>
                <mat-icon [style.color]="severityColors.get(newCommentSeverity)" class="severity-icon">
                  {{ severityIcons.get(newCommentSeverity) }}
                </mat-icon>&nbsp;{{ severityNames.get(newCommentSeverity) }}
              </mat-select-trigger>
              <mat-option *ngFor="let severity of severities" [value]="severity">
                <mat-icon [style.color]="severityColors.get(severity)" class="severity-icon">
                  {{ severityIcons.get(severity) }}
                </mat-icon>&nbsp;{{ severityNames.get(severity) }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
        <td style="width: 0; cursor: pointer;">
          <a (click)="addObjectComment()">
            <mat-icon>send</mat-icon>
          </a>
        </td>
      </tr>
    </table>
  </mat-card-content>
</mat-card>
